// Sidebar.jsx
import { AccountToggle } from "./AccountToggle";
import { Link, useLocation } from "react-router-dom";
// import roket from "./../../images/rocket.png";

export const Sidebar = () => {
  const location = useLocation();
  return (
    <div className="w-75 h-screen px-6 py-6 flex flex-col border-r border-black/10 ">
      <AccountToggle />

      {/* Navigation Buttons */}
      <div className="mt-6 flex flex-col gap-3">
        <h1 className="uppercase pl-3 text-[13px] font-normal ">Home</h1>
        <Link
          to="/dashboard"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/dashboard")
              ? "bg-[#daffeb] text-[#2da562] border-l-4 border-[#2da562]"
              : "text-black hover:text-[#2da562] hover:bg-[#daffeb]"
          } rounded-lg font-semibold py-3 px-4 mb-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] icon icon-tabler icon-tabler-layout-dashboard iconClass"
          >
            {" "}
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
            <path d="M4 4h6v8h-6z"></path> <path d="M4 16h6v4h-6z"></path>{" "}
            <path d="M14 12h6v8h-6z"></path>{" "}
            <path d="M14 4h6v4h-6z"></path>{" "}
          </svg>
          Dashboard
        </Link>
        <h1 className="uppercase pl-3 text-[13px] font-normal">Pages</h1>

        <Link
          to="/event"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/event") ||
            location.pathname.includes("/event/create") ||
            location.pathname.includes("/event/update")
              ? "bg-[#daffeb] text-[#2da562] border-l-4 border-[#2da562]"
              : "text-black hover:text-[#2da562] hover:bg-[#daffeb]"
          } rounded-lg font-semibold py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] iconClass"
          >
            <rect x="4" y="5" width="16" height="16" rx="2" />
            <line x1="16" y1="3" x2="16" y2="7" />
            <line x1="8" y1="3" x2="8" y2="7" />
            <line x1="4" y1="11" x2="20" y2="11" />
            <rect x="8" y="15" width="2" height="2" />
          </svg>
          Event
        </Link>
        <Link
          to="/hotel"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/hotel") ||
            location.pathname.includes("/hotel/create") ||
            location.pathname.includes("/hotel/update")
              ? "bg-[#daffeb] text-[#2da562] border-l-4 border-[#2da562]"
              : "text-black hover:text-[#2da562] hover:bg-[#daffeb]"
          } rounded-lg font-semibold py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] iconClass"
          >
            <path d="M3 21h18" />
            <path d="M5 21V5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
            <path d="M9 7h1" />
            <path d="M9 11h1" />
            <path d="M9 15h1" />
            <path d="M14 7h1" />
            <path d="M14 11h1" />
            <path d="M14 15h1" />
          </svg>
          Hotel
        </Link>
        <Link
          to="/delegate"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/delegate") ||
            location.pathname.includes("/delegate/create") ||
            location.pathname.includes("/delegate/update")
              ? "bg-[#daffeb] text-[#2da562] border-l-4 border-[#2da562]"
              : "text-black hover:text-[#2da562] hover:bg-[#daffeb]"
          } rounded-lg font-semibold py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] iconClass"
          >
            <circle cx="8" cy="8" r="3" />
            <circle cx="16" cy="8" r="3" />
            <path d="M3 21a5 5 0 0 1 10 0" />
            <path d="M11 21a5 5 0 0 1 10 0" />
          </svg>
          Delegates
        </Link>
      </div>
    </div>
  );
};
